<template>
  <div>
    <smart-header/>
    <background/>


    <layout-renderer ref="layout" :page="city"/>
    <spacing value="4rem"/>


  </div>
</template>

<script>
  import LayoutRenderer from "./LayoutRenderer";
  import Background from "./Background";
  import Countdown from "./blocks/Countdown";
  import Spacing from "./blocks/Spacing";
  import SmartFooter from "./SmartFooter";
  import SmartHeader from "./SmartHeader";

  export default {
    components: {
      SmartHeader,
      SmartFooter,
      Spacing,
      Countdown,
      Background,
      LayoutRenderer
    },
    name: "page",
    data() {
      return {
        city: null
      }
    },
    created() {
      this.city = this.$route.params.city || 'home';
      this.scrollposition = 0;
    },
    mounted() {
      console.log('mounted', this.city);
    },
    activated() {
      window.scroll(0, this.scrollposition);
    },
    beforeRouteLeave(to, from, next) {
      this.scrollposition = window.scrollY;
      next();
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Page.vue